import React, { useState, useEffect } from "react";
import { CustomInput } from 'reactstrap';

const SwitchCell = ({
  value: initialValue,
  row: { index, original, ...tt },
  column: { id, cc },
  updateMyData,
}) => {
  const [value, setValue] = useState(!!initialValue);

  const onChange = (e) => {
    updateMyData(index, id, e.target.checked);
  };

  useEffect(() => {
    setValue(!!initialValue);
  }, [initialValue]);

  return <CustomInput type="switch" id={`customSwitch_${id}_${index}_${original?.id || Math.random()}`} name={`customSwitch_${id}_${index}Switch`} checked={value} onChange={onChange} />
};

export default SwitchCell;
